const ClientReducer = (state, action) => {
  switch (action.type) {
    case "GET_CATEGORIES": {
      return {
        ...state,
        loading: false,
        categories: action.payload,
      };
    }
    case "SET_LOADING": {
      return { ...state, loading: true };
    }
    case "CLEAR_LOADING": {
      return { ...state, loading: false };
    }

    case "SET_SELECTED_DEPARTMENT": {
      return {
        ...state,
        selectedAttributes: [],
        selectedDepartment: action.payload,
        isDepartemntSelected: true,
        keysArr: [],
      };
    }
    case "CLEAR_SELECTED_CATEGORY": {
      return {
        ...state,
        selectedCategory: {},
        isCategorySelected: false,
        categoryClasses: [],
        classSubClasses: [],
        selectedClass: {},
        isSubclassSelected: false,
        isClassSelected: false,
        showCategories: true,
      };
    }
    case "CLEAR_CLIENT_LIST": {
      return {
        ...state,
        clientList: []
      };
    }

    case "SET_SELECTED_CLASS": {
      return {
        ...state,
        selectedAttributes: [],
        selectedClass: action.payload.class,
        isClassSelected: true,
        showCategories: false,
        isSubclassSelected: false,
        selectedSubclass: {},
        clientList: action.payload.clients,
        enableShowMore: action.payload.clients.length > 9 ? true : false,
        page: 1,
        keysArr: [],

        classSubClasses: state.subClasses.filter(
          (sub) => sub.parentId === action.payload.class.id
        ),
      };
    }

    case "CLEAR_SELECTED_CLASS": {
      return {
        ...state,
        isClassSelected: false,
        showCategories: true,
        selectedClass: null,
      };
    }

    case "SET_CLASSES": {
      return {
        ...state,
        classes: action.payload,
      };
    }
    case "SET_SUBCLASSES": {
      return {
        ...state,
        subClasses: action.payload,
      };
    }

    case "FILTER_CLASSES": {
      return {
        ...state,
        categoryClasses: state.classes.filter(
          (c) => c.parentId === action.payload
        ),
      };
    }

    case "SUBCLASS_SELECTED": {
      return {
        ...state,
        isSubclassSelected: true,
        selectedSubclass: action.payload,
        clientList: action.payload2,
        enableShowMore: action.payload2.length > 9 ? true : false,
        page: 1,
        keysArr: [],
      };
    }

    case "CLEAR_SUBCLASS": {
      return {
        ...state,
        isSubclassSelected: false,
        selectedSubclass: {},
      };
    }

    case "SHOW_CLIENT_LIST":
      return {
        ...state,
        isShowClientList: true,
      };

    case "HIDE_CLIENT_LIST":
      return {
        ...state,
        isShowClientList: false,
      };

    case "INCREMENT_PAGE":
      return {
        ...state,
        page: state.page + 1,
      };

    case "APPEND_TO_CLIENTS":
      return {
        ...state,
        clientList: [...state.clientList, ...action.payload],
        enableShowMore: action.payload.length > 9 ? true : false,
      };

    case "RESET_PAGE":
      return {
        ...state,
        // page: 1,
      };

    case "SET_CLIENT_LIST":
      return {
        ...state,
        clientList: action.payload,
        enableShowMore: action.payload.length > 9 ? true : false,
      };

    case "CLEAR_CATEGORY_SEARCH":
      return {
        ...state,
        clientList: [],
        selectedCategory: {},
        selectedClass: {},
        selectedSubclass: {},
        isCategorySelected: false,
        isClassSelected: false,
        isSubclassSelected: false,
        showCategories: true,
      };

    case "SET_SEARCH_BY_NAME":
      return {
        ...state,
        isSearchByName: action.payload,
        keysArr: [],
      };

    case "SET_SELECTED_CLIENT":
      return {
        ...state,
        selectedClient: action.payload,
        isClientSelected: true,
      };
    case "CLEAR_SELECTED_CLIENT":
      return {
        ...state,
        selectedClient: {},
        isClientSelected: false,
        displayedClient: {},
      };

    case "SET_KEYWORDS":
      return {
        ...state,
        keywords: action.payload,
      };

    case "SET_KEYS_ARR":
      return {
        ...state,
        keysArr: action.payload,
      };
    case "CLEAR_CLASS_SUB_CLIENT":
      return {
        ...state,
        selectedCategory: {},
        selectedClass: {},
        selectedSubclass: {},
        selectedClient: {},
        keywords: "",
      };

    case "SET_DISPLAYED_CLIENT":
      return {
        ...state,
        displayedClient: action.payload,
      };

    case "SET_SELLGIFTCARDS": {
      return {
        ...state,
        sellGiftcardsFilter: action.payload,
      };
    }
    case "SET_OFFERPROMO": {
      return {
        ...state,
        offerPromotion: action.payload,
      };
    }
    case "SET_HASWEBSTORE": {
      return {
        ...state,
        hasWebstore: action.payload,
      };
    }

    case "GET_CLNT_STATE_FROM_LOCAL": {
      return { ...state, ...action.payload };
    }

    case "RESET_CLIENT_CONTEXT": {
      return { ...state, ...action.payload };
    }

    case "SET_CLASS_ATTRIBUTES": {
      return {
        ...state,
        classAttributes: action.payload,
      };
    }

    case "SET_SELECTED_ATTRIBUTES": {
      return {
        ...state,
        selectedAttributes: action.payload,
      };
    }
    case "CLEAR_SELECTED_ATTRIBUTES": {
      return {
        ...state,
        selectedAttributes: [],
      }
    }

    case "SET_COMP_NAME_SEARCH": {
      return {
        ...state,
        companyNameSearch: action.payload,
      };
    }

    case "CLEAR_COMPANY_NAME_SEARCH": {
      return {
        ...state,
        companyNameSearch: "",
      };
    }

    case "CLIENT_LIST_EMPTY_TRUE": {
      return {
        ...state,
        clientListEmpty: true
      }
    }

    case "CLIENT_LIST_EMPTY_FALSE": {
      return {
        ...state,
        clientListEmpty: false
      }
    }
    
    default:
      return state;
  }
};

export default ClientReducer;
